import { DOCUMENT_EXTENSIONS, DOCUMENT_REQUEST_LOCATION, IDocumentRequest } from '../../../models/utilities/document-request';
import { API_METHODS } from '../../../models/utilities/type-models';
import { ApiEndpoints } from '../../../utils/app-constants';
import { ShipmentType } from '../enums/_index';

export class DocumentRoutePaperwork implements IDocumentRequest {

    public filename : string = '';
    public fileExtension : DOCUMENT_EXTENSIONS = 'pdf';
    public openInTab : boolean = false;
    public url : string = ''; 
    public reportLocation : DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType : API_METHODS = 'GET';

    constructor(id: string|number, routeType : ShipmentType) {
        
        this.url = ApiEndpoints.shipment(ApiEndpoints.TRANSPORTATION_ROUTE_PAPERWORK, routeType).formattify(id);
        this.filename = `${ routeType === ShipmentType.Truck ? 'Truck' : 'Container' }_${ id }_Paperwork`;

    }

}
